import { Footer } from "../../../MarketingSiteComponents/Footer";

const DeliveryPolicy = () => {
    return (
        <>
            <div style={{ textAlign: 'left', margin: '10px 1px', fontFamily: 'poppins', minHeight: '70vh' }} className="container mx-auto p-6 text-gray-800">
                <p>&nbsp;</p>

                <strong style={{ fontSize: '3vh' }}>Delivery Policy</strong><br />
                <p>&nbsp;</p>

                <p>All products available for purchase on {window.location.origin === 'https://www.medineer.ai' ? 'MEDINEER.AI' : 'learnerFitbit'} are digital products and delivered in digital mode only. There is no physical products to be shipped for digital products.</p>
                <p>Your product should be available to access within 24 hours after your payment is confirmed. You should create your userid and password with valid email id to access the product. The email id can be used afterward to reset your password. The product should be available to access on our website and sometime on out mobile app as well. Please note, that all access are tracked in terms of the location (via IP Address) and time to prevent software fraud.</p>
            </div>
            <Footer />
        </>

    );
};

export default DeliveryPolicy;
